import { render, staticRenderFns } from "./EventTicketSellsTable.vue?vue&type=template&id=79633424&"
import script from "./EventTicketSellsTable.vue?vue&type=script&lang=js&"
export * from "./EventTicketSellsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports